import { css as v, LitElement as u, html as o, nothing as d } from "lit";
import { property as n, state as g, customElement as m } from "lit/decorators.js";
import { classMap as h } from "lit/directives/class-map.js";
import { b as f } from "./styles-scZ6dVz-.js";
var x = Object.defineProperty, b = Object.getOwnPropertyDescriptor, l = (r, e, i, t) => {
  for (var a = t > 1 ? void 0 : t ? b(e, i) : e, c = r.length - 1, p; c >= 0; c--)
    (p = r[c]) && (a = (t ? p(e, i, a) : p(a)) || a);
  return t && a && x(e, i, a), a;
};
let s = class extends u {
  constructor() {
    super(...arguments), this.multiple = !1, this.disabled = !1, this.compact = !1, this.dropText = "Drop files here or click to browse", this._files = [], this._isDragging = !1, this._handleDragOver = (r) => {
      r.preventDefault(), r.stopPropagation(), this.disabled || (this._isDragging = !0);
    }, this._handleDragLeave = (r) => {
      r.preventDefault(), r.stopPropagation(), this._isDragging = !1;
    }, this._handleDrop = (r) => {
      if (r.preventDefault(), r.stopPropagation(), this._isDragging = !1, this.disabled) return;
      const e = r.dataTransfer?.files;
      e && this._processFiles(e);
    }, this._handleClick = () => {
      this.disabled || this._inputRef?.click();
    }, this._handleInputChange = (r) => {
      const e = r.target;
      e.files && (this._processFiles(e.files), e.value = "");
    };
  }
  get files() {
    return this._files;
  }
  _generateId() {
    return `file-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
  }
  _formatFileSize(r) {
    if (r === 0) return "0 Bytes";
    const e = 1024, i = ["Bytes", "KB", "MB", "GB"], t = Math.floor(Math.log(r) / Math.log(e));
    return `${parseFloat((r / Math.pow(e, t)).toFixed(2))} ${i[t]}`;
  }
  _processFiles(r) {
    const e = [];
    for (let i = 0; i < r.length; i++) {
      const t = r[i];
      if (this.maxFiles && this._files.length + e.length >= this.maxFiles)
        break;
      let a = "pending", c;
      this.maxSize && t.size > this.maxSize && (a = "error", c = `File exceeds maximum size of ${this._formatFileSize(this.maxSize)}`), e.push({
        id: this._generateId(),
        file: t,
        name: t.name,
        size: t.size,
        type: t.type,
        progress: 0,
        status: a,
        error: c
      });
    }
    this.multiple ? this._files = [...this._files, ...e] : this._files = e.slice(0, 1), this.dispatchEvent(
      new CustomEvent("ark-select", {
        detail: { files: e },
        bubbles: !0,
        composed: !0
      })
    );
  }
  /** Update file progress */
  updateProgress(r, e) {
    this._files = this._files.map(
      (i) => i.id === r ? { ...i, progress: Math.min(100, Math.max(0, e)), status: "uploading" } : i
    );
  }
  /** Mark file as success */
  markSuccess(r) {
    this._files = this._files.map(
      (e) => e.id === r ? { ...e, progress: 100, status: "success" } : e
    );
  }
  /** Mark file as error */
  markError(r, e) {
    this._files = this._files.map(
      (i) => i.id === r ? { ...i, status: "error", error: e } : i
    );
  }
  /** Remove a file */
  removeFile(r) {
    const e = this._files.find((i) => i.id === r);
    this._files = this._files.filter((i) => i.id !== r), e && this.dispatchEvent(
      new CustomEvent("ark-remove", {
        detail: { file: e },
        bubbles: !0,
        composed: !0
      })
    );
  }
  /** Clear all files */
  clearFiles() {
    this._files = [], this.dispatchEvent(
      new CustomEvent("ark-clear", {
        bubbles: !0,
        composed: !0
      })
    );
  }
  _renderFileIcon(r) {
    return r.startsWith("image/") ? o`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect width="18" height="18" x="3" y="3" rx="2" ry="2"/>
          <circle cx="9" cy="9" r="2"/>
          <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/>
        </svg>
      ` : r === "application/pdf" ? o`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline points="14 2 14 8 20 8"/>
          <line x1="16" y1="13" x2="8" y2="13"/>
          <line x1="16" y1="17" x2="8" y2="17"/>
          <polyline points="10 9 9 9 8 9"/>
        </svg>
      ` : o`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
        <polyline points="14 2 14 8 20 8"/>
      </svg>
    `;
  }
  _renderStatusIcon(r) {
    return r === "success" ? o`
        <svg class="status-icon success" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M20 6 9 17l-5-5"/>
        </svg>
      ` : r === "error" ? o`
        <svg class="status-icon error" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"/>
          <line x1="12" y1="8" x2="12" y2="12"/>
          <line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
      ` : d;
  }
  firstUpdated() {
    this._inputRef = this.shadowRoot?.querySelector(".file-input");
  }
  render() {
    const r = {
      "file-upload": !0,
      compact: this.compact
    }, e = {
      dropzone: !0,
      dragging: this._isDragging,
      disabled: this.disabled
    }, i = this.hintText || [
      this.accept ? `Accepted: ${this.accept}` : "",
      this.maxSize ? `Max size: ${this._formatFileSize(this.maxSize)}` : "",
      this.maxFiles ? `Max files: ${this.maxFiles}` : ""
    ].filter(Boolean).join(" • ");
    return o`
      <div class=${h(r)}>
        <input
          type="file"
          class="file-input"
          accept=${this.accept || ""}
          ?multiple=${this.multiple}
          ?disabled=${this.disabled}
          @change=${this._handleInputChange}
        />

        <div
          part="dropzone"
          class=${h(e)}
          @dragover=${this._handleDragOver}
          @dragleave=${this._handleDragLeave}
          @drop=${this._handleDrop}
          @click=${this._handleClick}
        >
          <svg class="dropzone-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="17 8 12 3 7 8"/>
            <line x1="12" y1="3" x2="12" y2="15"/>
          </svg>
          <div class="dropzone-text">
            ${this.dropText.includes("click") ? o`<span>${this.dropText.replace("click", "")}<strong>click</strong></span>` : o`<span>${this.dropText}</span>`}
          </div>
          ${i ? o`<div class="dropzone-hint">${i}</div>` : d}
        </div>

        ${this._files.length > 0 ? o`
              <div part="file-list" class="file-list">
                ${this._files.map(
      (t) => o`
                    <div part="file-item" class="file-item ${t.status}">
                      <div class="file-icon">${this._renderFileIcon(t.type)}</div>
                      <div class="file-info">
                        <div class="file-name">${t.name}</div>
                        <div class="file-meta">
                          <span>${this._formatFileSize(t.size)}</span>
                          ${t.status === "uploading" ? o`<span>• ${t.progress}%</span>` : d}
                        </div>
                        ${t.error ? o`<div class="file-error">${t.error}</div>` : d}
                        ${t.status === "uploading" ? o`
                              <div class="progress-container">
                                <div
                                  class="progress-bar"
                                  style="width: ${t.progress}%"
                                ></div>
                              </div>
                            ` : d}
                      </div>
                      ${this._renderStatusIcon(t.status)}
                      <button
                        type="button"
                        class="remove-btn"
                        @click=${(a) => {
        a.stopPropagation(), this.removeFile(t.id);
      }}
                        aria-label="Remove file"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <line x1="18" y1="6" x2="6" y2="18"/>
                          <line x1="6" y1="6" x2="18" y2="18"/>
                        </svg>
                      </button>
                    </div>
                  `
    )}
              </div>
            ` : d}
      </div>
    `;
  }
};
s.styles = [
  f,
  v`
      :host {
        display: block;
      }

      *,
      *::before,
      *::after {
        box-sizing: border-box;
      }

      .file-upload {
        font-family: var(--r5-font-body);
      }

      /* Drop zone */
      .dropzone {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: var(--r5-space-8);
        border: 2px dashed var(--r5-file-upload-border-color, var(--r5-border));
        border-radius: var(--r5-radius-lg);
        background-color: var(--r5-file-upload-bg, var(--r5-bg-muted));
        cursor: pointer;
        transition: all var(--r5-duration-fast) var(--r5-ease-default);
      }

      .dropzone:hover {
        border-color: var(--r5-color-primary-400);
        background-color: var(--r5-color-primary-50);
      }

      .dropzone.dragging {
        border-color: var(--r5-color-primary-500);
        background-color: var(--r5-color-primary-100);
        border-style: solid;
      }

      .dropzone.disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
      }

      .dropzone-icon {
        width: 3rem;
        height: 3rem;
        color: var(--r5-text-muted);
        margin-bottom: var(--r5-space-3);
      }

      .dropzone.dragging .dropzone-icon {
        color: var(--r5-color-primary-500);
      }

      .dropzone-text {
        font-size: var(--r5-text-sm);
        color: var(--r5-text-muted);
        text-align: center;
      }

      .dropzone-text strong {
        color: var(--r5-color-primary-600);
        font-weight: var(--r5-font-semibold);
      }

      .dropzone-hint {
        font-size: var(--r5-text-xs);
        color: var(--r5-text-muted);
        margin-top: var(--r5-space-2);
      }

      /* Hidden file input */
      .file-input {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border: 0;
      }

      /* File list */
      .file-list {
        display: flex;
        flex-direction: column;
        gap: var(--r5-space-2);
        margin-top: var(--r5-space-4);
      }

      .file-item {
        display: flex;
        align-items: center;
        gap: var(--r5-space-3);
        padding: var(--r5-space-3);
        border: 1px solid var(--r5-border);
        border-radius: var(--r5-radius-md);
        background-color: var(--r5-bg);
      }

      .file-item.error {
        border-color: var(--r5-color-danger-300);
        background-color: var(--r5-color-danger-50);
      }

      .file-item.success {
        border-color: var(--r5-color-success-300);
        background-color: var(--r5-color-success-50);
      }

      .file-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 2.5rem;
        height: 2.5rem;
        border-radius: var(--r5-radius-md);
        background-color: var(--r5-bg-muted);
        color: var(--r5-text-muted);
        flex-shrink: 0;
      }

      .file-icon svg {
        width: 1.25rem;
        height: 1.25rem;
      }

      .file-info {
        flex: 1;
        min-width: 0;
      }

      .file-name {
        font-size: var(--r5-text-sm);
        font-weight: var(--r5-font-medium);
        color: var(--r5-text);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .file-meta {
        display: flex;
        align-items: center;
        gap: var(--r5-space-2);
        font-size: var(--r5-text-xs);
        color: var(--r5-text-muted);
        margin-top: var(--r5-space-0-5);
      }

      .file-error {
        font-size: var(--r5-text-xs);
        color: var(--r5-color-danger-600);
        margin-top: var(--r5-space-0-5);
      }

      /* Progress bar */
      .progress-container {
        width: 100%;
        height: 4px;
        background-color: var(--r5-bg-muted);
        border-radius: var(--r5-radius-full);
        overflow: hidden;
        margin-top: var(--r5-space-2);
      }

      .progress-bar {
        height: 100%;
        background-color: var(--r5-color-primary-500);
        border-radius: var(--r5-radius-full);
        transition: width var(--r5-duration-normal) var(--r5-ease-default);
      }

      .file-item.success .progress-bar {
        background-color: var(--r5-color-success-500);
      }

      .file-item.error .progress-bar {
        background-color: var(--r5-color-danger-500);
      }

      /* Status icon */
      .status-icon {
        flex-shrink: 0;
        width: 1.25rem;
        height: 1.25rem;
      }

      .status-icon.success {
        color: var(--r5-color-success-500);
      }

      .status-icon.error {
        color: var(--r5-color-danger-500);
      }

      /* Remove button */
      .remove-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 1.75rem;
        height: 1.75rem;
        border: none;
        border-radius: var(--r5-radius-md);
        background: transparent;
        color: var(--r5-text-muted);
        cursor: pointer;
        transition: all var(--r5-duration-fast) var(--r5-ease-default);
        flex-shrink: 0;
      }

      .remove-btn:hover {
        background-color: var(--r5-color-danger-100);
        color: var(--r5-color-danger-600);
      }

      .remove-btn svg {
        width: 1rem;
        height: 1rem;
      }

      /* Compact variant */
      .compact .dropzone {
        padding: var(--r5-space-4);
        flex-direction: row;
        gap: var(--r5-space-3);
      }

      .compact .dropzone-icon {
        width: 1.5rem;
        height: 1.5rem;
        margin-bottom: 0;
      }

      .compact .dropzone-text {
        text-align: left;
      }

      .compact .dropzone-hint {
        margin-top: 0;
        margin-left: var(--r5-space-1);
      }
    `
];
l([
  n({ type: String })
], s.prototype, "accept", 2);
l([
  n({ type: Boolean })
], s.prototype, "multiple", 2);
l([
  n({ type: Number, attribute: "max-size" })
], s.prototype, "maxSize", 2);
l([
  n({ type: Number, attribute: "max-files" })
], s.prototype, "maxFiles", 2);
l([
  n({ type: Boolean, reflect: !0 })
], s.prototype, "disabled", 2);
l([
  n({ type: Boolean, reflect: !0 })
], s.prototype, "compact", 2);
l([
  n({ type: String, attribute: "drop-text" })
], s.prototype, "dropText", 2);
l([
  n({ type: String, attribute: "hint-text" })
], s.prototype, "hintText", 2);
l([
  g()
], s.prototype, "_files", 2);
l([
  g()
], s.prototype, "_isDragging", 2);
s = l([
  m("ark-file-upload")
], s);
export {
  s as A
};
//# sourceMappingURL=ark-file-upload-DGprZoXF.js.map
